import { Navigate } from 'react-router-dom';

export function getSession() {
  try {
    const raw = localStorage.getItem('vincle_session');
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session.auth || !session.expiry) return null;
    if (Date.now() > session.expiry) {
      localStorage.removeItem('vincle_session');
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function renewSession(session) {
  const updated = { ...session, expiry: Date.now() + 24 * 60 * 60 * 1000 };
  localStorage.setItem('vincle_session', JSON.stringify(updated));
  return updated;
}

// Guarda sessió sense enquestador_nom (post-login, abans de seleccionar nom)
export function saveAuthSession() {
  const session = {
    auth: true,
    enquestador_nom: '',
    expiry: Date.now() + 24 * 60 * 60 * 1000,
  };
  localStorage.setItem('vincle_session', JSON.stringify(session));
}

// Guarda sessió completa amb nom de l'enquestador
export function saveSession(nom) {
  const session = {
    auth: true,
    enquestador_nom: nom,
    expiry: Date.now() + 24 * 60 * 60 * 1000,
  };
  localStorage.setItem('vincle_session', JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem('vincle_session');
}

// ProtectedRoute: sessió vàlida + enquestador_nom present
export default function ProtectedRoute({ children }) {
  const session = getSession();
  if (!session || !session.enquestador_nom) {
    return <Navigate to="/login" replace />;
  }
  renewSession(session);
  return children;
}
